export enum CustomContactFieldType {
    FreeText = 0,
    SingleSelect = 1,
    MultipleSelect = 2,
    Boolean = 3,
    SingleSelectUser = 4,
    MultiSelectUser = 5,
    SmartField = 6
}
